import React from 'react';
import { Section, SectionSubTitle, Typography } from 'common/components';
import { createElementKey } from 'utils';
import {
  CONSTRUCTION_HOUSES_BENEFITS_DATA,
  ConstructionHousesBenefitsStructure,
} from './construction-houses-benefits-constants';
import {
  constructionHousesBenefitsList,
  constructionHousesBenefitsSection,
  constructionHousesBenefitsText,
} from './construction-houses-benefits-styles';

/**
 * Вью секции преимуществ Леруа
 */

export const ConstructionHousesBenefits: React.FC = () => (
  <Section className={constructionHousesBenefitsSection}>
    <SectionSubTitle margin="m">С&nbsp;нами надёжно и&nbsp;выгодно</SectionSubTitle>
    <ul className={constructionHousesBenefitsList}>
      {CONSTRUCTION_HOUSES_BENEFITS_DATA.map(
        ({ icon, text }: ConstructionHousesBenefitsStructure, index: number) => (
          <li key={createElementKey('benefits', index)}>
            {icon}
            <Typography className={constructionHousesBenefitsText} size="body_short" variant="m">
              {text}
            </Typography>
          </li>
        )
      )}
    </ul>
  </Section>
);
